import { useQuery } from '@tanstack/react-query';
import { getCommunityDashboardSnapshot } from '../lib/home';
import type { CommunityDashboardSnapshotResponse } from '../types';

export const communityDashboardKeys = {
  all: ['community-dashboard'] as const,
  snapshot: () => [...communityDashboardKeys.all, 'snapshot'] as const,
};

export function useCommunityDashboardSnapshot(enabled: boolean = true) {
  return useQuery<CommunityDashboardSnapshotResponse>({
    queryKey: communityDashboardKeys.snapshot(),
    queryFn: getCommunityDashboardSnapshot,
    staleTime: 60 * 1000,
    retry: false,
    enabled,
  });
}
